import { useState, useEffect } from 'react';
import { Formik, withFormik } from 'formik';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import _isEmpty from 'lodash/isEmpty';
import { PaymentFlowLayout, AmountFrom, Modal, CheckBox } from 'components';
import { withLayout } from 'hocs';
import { withStore } from 'store';
import { priceFormat } from 'util/prices';
import {
  resetExternalGiftTable,
} from 'store/actions/externalGiftTable';
import GiftItem from 'components/gifts-table/GiftsList/GiftItem/index';
import { mapPropsToValues as mapGiftsProductsToValues } from 'components/gifts-table/GiftsList/config';
import { useWindowSize } from 'hooks';
import styles from './styles.module.scss';
import {
  STEPS,
  PAYMENT_STEPS,
  stepsInitialValues,
  stepsSchemas,
  stepsTitles,
  getIndexOfStep,
  actions,
} from './config';

function GiftDedication({
  dispatch,
  updateCartInfo,
  fetchGiftTableInfo,
  fetchExternalGiftTableProducts,
  tableInfo,
  shoppingCartProducts = []
}) {
  const [valuesCart, setValuesCart] = useState({});
  const [acceptPayment, setAcceptPayment] = useState(false);
  const [currentStep, setCurrentStep] = useState(STEPS.ONE);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const { tableId } = useParams();
  const [, { isMobile }] = useWindowSize();

  const handleCloseModal = () => {
    setShowModal(false);
    handleBack();
  };

  const handleSubmitStepOne = (values) => {
    setShowModal(true);
    updateCartInfo(values, false);
    setCurrentStep(STEPS.TWO);
  };

  const handleSubmitStepTwo = () => {
    setCurrentStep(STEPS.THREE);
  };

  const handleSubmitStepThree = () => {
    history.push('/');
  };

  const SUBMIT_BY_STEPS = {
    [STEPS.ONE]: handleSubmitStepOne,
    [STEPS.TWO]: handleSubmitStepTwo,
    [STEPS.THREE]: handleSubmitStepThree,
  };

  const handleSubmit = (values) => {
    setValuesCart(values);
    const onSubmit = SUBMIT_BY_STEPS[currentStep];
    onSubmit(values);
  };

  const handleSubmitModal = () => {
    setShowModal(false);
    //  console.log("valuesCart: ",valuesCart);
    updateCartInfo(valuesCart, true);
  }

  const handleAcceptPayment = (event) => {
    setAcceptPayment(event.target.value);
  }

  const handleBack = () => {
    if (currentStep === STEPS.THREE) return;

    const [currentStepIndex] = getIndexOfStep(currentStep);
    const [, lastStep] = Object.entries(STEPS).find(
      (_, index) => index === currentStepIndex - 1
    );
    setCurrentStep(lastStep);
  };

  useEffect(() => {
    if (tableId) fetchGiftTableInfo({ id: tableId, isExternal: true });
  }, [tableId]);

  useEffect(() => {
    if (!_isEmpty(tableInfo)) {
      fetchExternalGiftTableProducts(tableInfo);
    }

    //      BANDERA PARA VALIDAR RESPUESTA DE CAJA
    window.localStorage.setItem('statusRedirectCaja', 0);
    console.log('Iniciado statusRedirectCaja')
  }, [tableInfo]);

  useEffect(() => () => dispatch(resetExternalGiftTable()), []);

  const Step = PAYMENT_STEPS[currentStep];

  const initialValues = stepsInitialValues[currentStep];
  const validationSchema = stepsSchemas[currentStep];

  const totalSteps = Object.entries(STEPS);
  const [currentStepIndex] = getIndexOfStep(currentStep) || [1];

  const title = stepsTitles[currentStep];

  return (
    <>
      <PaymentFlowLayout titleBack='Dedicatoria del regalo'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnChange
          validateOnBlur
        >
          {(formikProps) => {
            const disabledNext = Object.values(formikProps.errors).length > 0;

            return (
              <div style={{
                marginTop: !isMobile?'8rem':'4.5rem',
              }}>
                <div className="d-flex">
                  <AmountFrom
                    current={currentStepIndex ? currentStepIndex + 1 : 1}
                    from={totalSteps.length}
                  />
                </div>

                <div>
                  <h4 className="font-weight-bold text-center">{title}</h4>
                </div>

                {Step && <Step {...formikProps} />}

                {currentStep === STEPS.ONE && (
                  <div className={styles.backAndNextRow}>
                    {currentStep !== STEPS.ONE && (
                      <Button
                        variant="secondary"
                        className="btn-with-shadow mx-2"
                        onClick={handleBack}
                      >
                        {currentStep === STEPS.THREE
                          ? 'Seguir comprando'
                          : 'Atrás'}
                      </Button>
                    )}

                    <Button
                      disabled={disabledNext}
                      className={`${disabledNext ? 'btn-disabled' : ''} mx-2`}
                      onClick={formikProps.handleSubmit}
                      type="submit"
                    >
                      {currentStep === STEPS.THREE
                        ? 'Cerrar sesión'
                        : 'Siguiente'}
                    </Button>
                  </div>
                )}
              </div>
            );
          }}
        </Formik>
      </PaymentFlowLayout>
      <Modal
          show={showModal}
          onClose={handleCloseModal}
          withActionButtons
          disabledSubmit={!acceptPayment}
          onAction={handleCloseModal}
          headerBackground="#ED0045"
          titleHeader="Confirmación de regalo"
          titleHeaderClassName="text-center text-white font-weight-bold w-100"
          variant="completed"
          variantOnlyInMobile
          withHeader
          subtitle={            
            <p className="text-justify mt-4 mb-4">
              <AmountFrom
                current={currentStepIndex ? currentStepIndex + 1 : 1}
                from={totalSteps.length}
              />
              Estás a punto de comprar para el evento <strong>"{tableInfo?.type?.name}"</strong> de <strong>{tableInfo?.name?.split('-').pop()}</strong>.
            </p>
          }
          onSubmit={handleSubmitModal}
          contentClassName={!isMobile?'':'border-top'}
          showBack={isMobile} // sirve para mostrar en la modal el componente Back

        >
          <div>
            <strong>Lista de regalos</strong> ({
            shoppingCartProducts.length
            ? shoppingCartProducts.map(item => item.quantity * 1).reduce((prev, next) => prev + next)
              : 0
            } artículos)
          </div>
          {shoppingCartProducts.map((giftProduct) => (
                <GiftItem
                  id={giftProduct.id}
                  item={giftProduct}
                  type="minimalist"
                  onCancelScan={handleCloseModal}
                />
              ))}
          <div className="d-flex justify-content-end">
            <strong>Total a pagar:
              ${shoppingCartProducts.length
                ? priceFormat(shoppingCartProducts.map(item => item.price * item.quantity).reduce((prev, next) => prev + next))
              : 0} MXN
            </strong>
          </div>
          <div className="ml-4">
            <CheckBox
              name="acceptPayment"
              label="Estoy de acuerdo de proceder a la compra"
              className="p-0"
              containerClassName="p-0"
              onChange={handleAcceptPayment}
            />
          </div>
        </Modal>
    </>
  );
}

const mapPropsToValues = ({ shoppingCartProducts }) =>
  mapGiftsProductsToValues({
    data: { results: { list: shoppingCartProducts } },
  });

export default withLayout(
  withStore(
    {
      mapStateToProps: (state) => ({
        tableInfo: state.externalGiftTable.giftTableInfo.data,
        shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
      }),
    },
    actions
  )(withFormik({ mapPropsToValues })(GiftDedication))
);
